import React, { useContext } from "react";
import { DesignAssetContext } from "../../pages/CustomHooks/ContextApi";
import embLabels from "../../config/emb-labels-en.json";

const Ecc = ({height}) => {
  const {
    coordinates: {
      busbarCordinates: { busStart },
      ecc: { width },
    },
    siteType,
    projectKind,
    switchboardType,
    rectangleWidth,
    count,
    loadSide,
  } = useContext(DesignAssetContext);
  return (
    <>
      {switchboardType === embLabels.EXISTING_SWITCHBOARD ? (
        <svg>
          <g id="ECC1">
            <svg>
              <g
                id="ECC1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <g id="ECC1" transform="translate(-532.000000, -514.000000)">
                  <g
                    id="SLD/Infos/Microgrid_Background"
                    transform="translate(532.000000, 514.000000)"
                  >
                    <rect
                      id="Rectangle-Copy-24"
                      stroke="var(--se-sld-circline)"
                      strokeWidth="3"
                      x="90"
                      y="170"
                      // y={loadSide==="LOAD_SIDE"?"200":"170"}
                      // width="570"
                      // width={CBLoadList.length <= 3 ? "420" : CBLoadList.length === 4 ? "450" : "570"}
                      width={300}
                      //height={loadSide==="LOAD_SIDE"?"200.3":"205.3"}
                      height="180.3"
                      rx="16"
                      // height="205.3"
                    />
                    <text
                      id="AAA"
                      fontFamily="Nunito-Regular, Nunito"
                      fontSize="18"
                      fontWeight="normal"
                      fill="var(--se-sld-circline)"
                    >
                      <tspan
                        x={loadSide ==="LOAD_SIDE"?"130":"200"}
                        //  y={loadSide==="LOAD_SIDE"?"390":"360"}
                        y="330"
                      >
                        Existing Switchboard
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
            </svg>
          </g>
          <g id="ECC2">
            <svg>
              <g
                id="ECC2"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <g id="ECC2" transform="translate(-532.000000, -514.000000)">
                  <g
                    id="SLD/Infos/Microgrid_Background"
                    transform="translate(532.000000, 514.000000)"
                  >
                    <rect
                      id="Rectangle-Copy-24"
                      stroke="var(--se-sld-circline)"
                      strokeWidth="3"
                      x={busStart}
                      y="372"
                      width={rectangleWidth}
                      height="190"
                      rx="16"
                    />
                    <text
                      id="AAA"
                      fontFamily="Nunito-Regular, Nunito"
                      fontSize="18"
                      fontWeight="normal"
                      fill="var(--se-sld-circline)"
                    >
                      <tspan
                        x={
                          count?.derCount === 4
                            ? "810"
                            : count?.derCount === 5
                            ? "950"
                            : count?.derCount === 6
                            ?"1000"
                            :790
                        }
                        // y={loadSide==="LOAD_SIDE"?"580":"520"}
                        y="550"
                      >
                        Energy Control Center
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
            </svg>
          </g>
        </svg>
      ) : (
        <svg x={count?.evCount === 1?"25":"0"}>
          {" "}
          <g id="ECC">
            {" "}
            <svg>
              {" "}
              <g
                id="ECC"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                {" "}
                <g id="ECC" transform="translate(-532.000000, -514.000000)">
                  {" "}
                  <g
                    id="SLD/Infos/Microgrid_Background"
                    transform="translate(532.000000, 514.000000)"
                  >
                    {" "}
                    <rect
                      id="Rectangle-Copy-24"
                      stroke="var(--se-sld-circline)"
                      strokeWidth="3"
                      x={projectKind?.isMGaaSETOIsland? count?.evCount ? "330" :"350":"360"}
                      y="269"
                      width={rectangleWidth}
                      height={height??"180"}
                      rx="16"
                    />{" "}
                    <text
                      id="AAA"
                      fontFamily="Nunito-Regular, Nunito"
                      fontSize="18"
                      fontWeight="normal"
                      fill="var(--se-sld-circline)"
                    >
                      {" "}
                      <tspan x={  count?.derCount === 6
                          ?900
                          :count?.derCount === 5
                          ?800
                          :count?.derCount === 4
                          ?700
                          :count?.derCount === 3
                          ?500:""} y="440">
                        Low Voltage{" "} Switchboard
                      </tspan>
                     
                    </text>{" "}
                  </g>{" "}
                </g>{" "}
              </g>{" "}
            </svg>{" "}
          </g>{" "}
        </svg>
      )}
    </>
  );
};

export default Ecc;
